import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Vertical from '@/pages/Vertical';
import Partner from '@/pages/Partner';
import NotFound from '@/pages/NotFound';

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
    }, [pathname]);
    return null;
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main data-testid="app-main">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/verticals/:slug" element={<Vertical />} />
                        <Route path="/partner" element={<Partner />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: '#1A1918',
                            color: '#F9F6F0',
                            border: '1px solid #4A4844',
                            borderRadius: '2px',
                            fontFamily: 'Manrope, sans-serif',
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}
